export default __webpack_public_path__ + "static/obi_image-c8f8a34657626fe411e0466e421ded15.png";